export default class AdminTestItemState {
  constructor() {
    // GET Test Item List
    this.adminTestItemList = {
      loading: false,
      data: {},
      error: null,
    };

    // GET/CREATE/UPDATE/DELETE Test Item
    this.adminTestItem = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Citation List
    this.citationList = {
      loading: false,
      data: [],
      error: null,
    };
    
    // GET_TEST_LINE_LAB_OPTIONAL_LIST
    this.testLabList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Archive List
    this.archiveList = {
      loading: false,
      data: [],
      error: null,
    };

    // GET_TEST_ITEM_TYPE
    this.testItemType = {
      loading: false,
      data: [],
      error: null,
    };

    // GET_TEST_ITEM_PRODUCTS
    this.testItemProducts = {
      loading: false,
      data: [],
      error: null,
    };

    // ARCHIVE_ADMIN_TEST_ITEM
    this.archiveAdminTestItem = {
      loading: false,
      data: {},
      error: null,
    };
  }
}
